import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import { BarChart3, Clock, Coins, Wallet } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { WhiteCtaButton } from "web_myplann/Shared/Components/WhiteCtaButton";

const R = Resources.Dashboard.FinancialBalance;

type Props = {
	onClick: () => void;
};

export const FinancialBalanceEmptyCard: FC<Props> = ({ onClick }) => {
	const theme = useTheme();
	const { t } = useResource();
	const white = theme.palette.darkmodeText.white;

	return (
		<Box
			position="relative"
			overflow="hidden"
			borderRadius={theme.radii.lg}
			sx={{ background: theme.gradients.premium }}
		>
			<Box position="absolute" top={12} left={12}>
				<Coins size={32} color={alpha(white, 0.07)} />
			</Box>
			<Box position="absolute" bottom={16} right={12}>
				<BarChart3 size={40} color={alpha(white, 0.07)} />
			</Box>
			<Stack alignItems="center" textAlign="center" px={2.4} py={3.6}>
				<Stack
					alignItems="center"
					justifyContent="center"
					width={56}
					height={56}
					mb={1.6}
					borderRadius="50%"
					bgcolor={alpha(white, 0.2)}
				>
					<Wallet size={28} color={white} />
				</Stack>
				<Typography variant="subtitle3" color={white} mb={0.8}>
					{t(R.emptyTitle)}
				</Typography>
				<Typography variant="caption" color={alpha(white, 0.8)} mb={1.6}>
					{t(R.emptyDescription)}
				</Typography>
				<Stack direction="row" alignItems="center" gap={0.8} mb={2}>
					<Clock size={12} color={alpha(white, 0.7)} />
					<Typography variant="button" color={alpha(white, 0.7)}>
						{t(R.emptyDuration)}
					</Typography>
				</Stack>
				<WhiteCtaButton onClick={onClick}>{t(R.emptyCta)} →</WhiteCtaButton>
			</Stack>
		</Box>
	);
};
